export const fontFamily = {
  Sora: "Sora",
  Gantari: "Gantari",
  Roboto: "Roboto",
} as const;
